import { useMemo, useState } from "react";
import { useDebounce } from "./useDebounce";

type Primitive = string | number | null | undefined;

interface Options {
    debounceMs?: number;
}

export function useKeywordFilter<T>(
    rows: T[],
    pick: (row: T) => Primitive[],
    options: Options = {}
) {
    const { debounceMs = 0 } = options;

    const [keyword, setKeyword] = useState("");
    const debouncedKeyword = useDebounce(keyword, debounceMs);

    const filteredRows = useMemo(() => {
        const q = (debounceMs ? debouncedKeyword : keyword).trim().toLowerCase();
        if (!q) return rows;

        return rows.filter((row) => {
            const haystack = pick(row)
                .filter((v): v is string | number => v !== null && v !== undefined && v !== "")
                .join(" ")
                .toLowerCase();

            return haystack.includes(q);
        });
    }, [rows, pick, keyword, debouncedKeyword, debounceMs]);

    const reset = () => setKeyword("");

    return {
        keyword,
        setKeyword,
        reset,
        filteredRows,
    };
}